import List from "../../containers/DestinationCategories/List";
import Entry from "../../containers/DestinationCategories";

const DestinationCategoryRoutes = [
  {
    path: "/destination-categories",
    exact: true,
    auth: true,
    component: List,
  },
  {
    path: "/destination-categories/:type",
    exact: true,
    auth: true,
    component: Entry,
  },
  {
    path: "/destination-categories/:type/:id",
    exact: true,
    auth: true,
    component: Entry,
  },
];

export default DestinationCategoryRoutes;



// WEBPACK FOOTER //
// ./src/routes/modules/destinationCategories.jsx